import React, { useEffect, useState, useMemo } from "react";
import QuestionNavigator from "./QuestionNavigator";
import QuestionsSection from "./QuestionsSection";
import { Box, Drawer } from "@mui/material";
import useDefaultStyles from "../testStyle/defaultStyle/defaultStyle";
import { useAttemptedQuestions } from "../../../context/AttemptedQuestionsContext";
import { useQuestion } from "../../../context/QuestionsContext";

function TestDefault() {
  const classes = useDefaultStyles();
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [currentSubject, setCurrentSubject] = useState([0]);
  const [subjectId, setSubjectId] = useState(0);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openInstructionsModal, setOpenInstructionsModal] = useState(false);

  const { fetchAttemptedQuestions } = useAttemptedQuestions();
  const { question } = useQuestion();

  const questionData = question?.subjects
    ?.map((subject) => subject?.questions)
    .flat();

  const subjectNames = question?.subjects?.map(
    (subject) => subject.subject_name
  );

const lengths = useMemo(() => {
  if (!question?.subjects) return [];
  
  return question.subjects.reduce((acc, subject, index) => {
    const prevSum = index > 0 ? acc[index - 1] : 0;
    acc.push(prevSum + subject.questions.length);
    return acc;
  }, []);
}, [question]);

  useEffect(() => {
    setCurrentSubject((prev) => [...prev, ...lengths]);
  }, [lengths]);

  useEffect(() => {
    let cumulative = 0;
    let subjectIndex = 0;

    for (let i = 0; i < question?.subjects?.length; i++) {
      cumulative += question.subjects[i].questions.length;
      if (currentQuestion < cumulative) {
        subjectIndex = i;
        break;
      }
    }

    const subjectId = question?.subjects[subjectIndex]?.id;
    setSubjectId(subjectId);
  }, [currentQuestion, question]);

  useEffect(() => {
    const storedExamId = sessionStorage.getItem("examId");
    if (storedExamId) {
      fetchAttemptedQuestions(storedExamId);
    }
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleToggleInstructionModal = () => {
    setOpenInstructionsModal(!openInstructionsModal);
  };

  return (
    <Box className={classes.mainContainer}>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile
        }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: { xs: 300 },
          },
        }}
      >
        <QuestionNavigator
          questionData={questionData}
          currentQuestion={currentQuestion}
          setCurrentQuestion={setCurrentQuestion}
          handleDrawerToggle={handleDrawerToggle}
          handleToggleInstructionModal={handleToggleInstructionModal}
          openInstructionsModal={openInstructionsModal}
        />
      </Drawer>

      <div className={classes.examprofile}>
        <QuestionNavigator
          questionData={questionData}
          currentQuestion={currentQuestion}
          setCurrentQuestion={setCurrentQuestion}
          handleDrawerToggle={handleDrawerToggle}
          handleToggleInstructionModal={handleToggleInstructionModal}
          openInstructionsModal={openInstructionsModal}
          subjectId={subjectId}
        />
      </div>
      <QuestionsSection
        subjectNames={subjectNames}
        currentSubject={currentSubject}
        currentQuestion={currentQuestion}
        setCurrentQuestion={setCurrentQuestion}
        questionData={questionData}
        subjectId={subjectId}
        handleDrawerToggle={handleDrawerToggle}
        handleToggleInstructionModal={handleToggleInstructionModal}
      />
    </Box>
  );
}

export default TestDefault;
